import { createFileRoute } from '@tanstack/react-router';

/**
 * Dashboards do módulo Pipeline — conteúdo 100% idêntico ao antigo /dashboards (as 3 visões:
 * Funil/Portfólio/Atividade). Decisão explícita (Bloco 1): não fatiar as visões entre módulos.
 *
 * Componente vem de pipeline.dashboards.lazy.tsx (code-splitting por rota, D4/DEC-060) — este
 * arquivo fica só com a definição da rota, sem importar DashboardsPage, então abrir outra aba do
 * Pipeline não baixa o bundle dos 3 dashboards.
 */
export const Route = createFileRoute('/pipeline/dashboards')({});
